const navigationSales = [
  {
    title: true,
    name: "Sales",
    class: "",
    wrapper: {
      element: "",
      attributes: {}
    }
  },
  {
    name: "Sales Rep",
    url: "/base/SalesRep",
    icon: "icon-pencil"
  },
  {
    name: "Sales Map Overview",
    url: "/base/SalesMap",
    icon: "icon-map"
  }
];

export default navigationSales;
